<template>
	<div class="license-plate-input">
		<!-- 车牌输入框 -->
		<div class="plate-container">
			<div v-for="(item, index) in inputCount" :key="`plate-${index}`" class="plate-item" :class="{
				'active': currentIndex === index,
				'province': index === 0,
				'new-energy': isNewEnergy && index === 7
			}" @click="focusInput(index)">
				<div class="input-display">
					{{ plateValue[index] || '' }}
				</div>
				<input ref="inputs" type="text" v-model="plateValue[index]" :maxlength="1" readonly
					@focus="onFocus(index)" @input="onInput(index, $event)" @keydown="onKeydown($event)"
					style="opacity: 0; position: absolute; width: 1px; height: 1px;">
			</div>
		</div>

		<!-- 新能源选项 -->
		<div class="energy-option">
			<label class="checkbox">
				<input type="checkbox" v-model="isNewEnergy" @change="onEnergyChange">
				<span class="checkmark"></span>
				新能源车牌
			</label>
		</div>

		<!-- 虚拟键盘 -->
		<div v-if="showKeyboard" class="keyboard">
			<div class="keyboard-header">
				<span>请输入车牌</span>
				<button @click="closeKeyboard">关闭</button>
			</div>
			<div class="keyboard-body">
				<div class="key-row" v-for="(row, rowIndex) in currentKeys" :key="`row-${rowIndex}`">
					<button v-for="(key, keyIndex) in row" :key="`key-${rowIndex}-${keyIndex}-${key || 'empty'}`"
						class="key" :class="{
							'special': ['切换', '删除', '完成'].includes(key),
							'disabled': !key
						}" @click="onKeyPress(key)" :disabled="!key">
						{{ key }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'LicensePlateInput',
	props: {
		defaultCity: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			plateValue: ['', '', '', '', '', '', '', ''],
			isNewEnergy: false,
			showKeyboard: true,
			currentIndex: 0,
			currentKeys: []
		}
	},
	computed: {
		inputCount() {
			return this.isNewEnergy ? 8 : 7
		},
		provinceKeys() {
			return [
				['京', '沪', '津', '渝', '冀', '豫', '云'],
				['辽', '黑', '湘', '皖', '鲁', '新', '苏'],
				['浙', '赣', '鄂', '桂', '甘', '晋', '蒙'],
				['陕', '吉', '闽', '贵', '粤', '青', '藏'],
				['川', '宁', '琼', '台', '港', '澳', '切换']
			]
		},
		normalKeys() {
			return [
				['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
				['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
				['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
				['Z', 'X', 'C', 'V', 'B', 'N', 'M', '学', '警', '删除'],
				['切换', '', '', '完成']
			]
		},
	},
	watch: {
		// 监听新能源状态变化，确保显示正确的位数
		isNewEnergy(newVal) {
			if (!newVal && this.plateValue[7]) {
				// 从新能源切换到普通车牌时，清空第8位
				this.plateValue[7] = '';
			}
		},
		defaultCity: {
    immediate: true, // 一开始 mounted 时也会执行一次
    handler(newVal) {
      if (newVal) {
        this.plateValue[0] = newVal;
        this.currentIndex = 1;
        this.updateKeyboard();
      }
    }
  }
	},
	mounted() {
		this.$nextTick(() => {
		if (this.defaultCity) {
			this.plateValue[0] = this.defaultCity;
			this.currentIndex = 1;
		}
		this.updateKeyboard();
	});
	},
	methods: {
		focusInput(index) {
			// 确保索引在有效范围内
			if (index >= this.inputCount) {
				index = this.inputCount - 1;
			}
			this.currentIndex = index;
			this.showKeyboard = true;
			this.updateKeyboard();
		},

		onFocus(index) {
			this.focusInput(index);
		},

		onInput(index, event) {
			const value = event.target.value.toUpperCase();

			// 验证输入是否合法
			if (this.isValidInput(index, value)) {
				// 使用Vue.set确保响应式更新
				this.$set(this.plateValue, index, value);

				// 自动跳转到下一个输入框
				if (value && index < this.inputCount - 1) {
					this.currentIndex = index + 1;
					this.updateKeyboard();
					this.$nextTick(() => {
						if (this.$refs.inputs && this.$refs.inputs[this.currentIndex]) {
							this.$refs.inputs[this.currentIndex].focus();
						}
					});
				}
			} else {
				// 输入不合法，清空
				this.$set(this.plateValue, index, '');
				event.target.value = '';
			}
		},

		onKeydown(event) {
			// 阻止键盘输入，强制使用虚拟键盘
			event.preventDefault();
		},

		// isValidInput(index, value) {
		// 	if (!value) return true; // 允许清空

		// 	if (index === 0) {
		// 		// 第一位必须是省份简称
		// 		const provinces = [
		// 			'京', '沪', '津', '渝', '冀', '豫', '云',
		// 			'辽', '黑', '湘', '皖', '鲁', '新', '苏',
		// 			'浙', '赣', '鄂', '桂', '甘', '晋', '蒙',
		// 			'陕', '吉', '闽', '贵', '粤', '青', '藏',
		// 			'川', '宁', '琼', '台', '港', '澳'
		// 		]
		// 		return provinces.includes(value);
		// 	} else {
		// 		// 其他位置可以是字母或数字
		// 		return /^[A-Z0-9]$/.test(value);
		// 	}
		// },
		isValidInput(index, value) {
			if (!value) return true; // 允许清空

			// ✅ 第一位必须是省份简称
			if (index === 0) {
				const provinces = [
					'京', '沪', '津', '渝', '冀', '豫', '云',
					'辽', '黑', '湘', '皖', '鲁', '新', '苏',
					'浙', '赣', '鄂', '桂', '甘', '晋', '蒙',
					'陕', '吉', '闽', '贵', '粤', '青', '藏',
					'川', '宁', '琼', '台', '港', '澳'
				];
				return provinces.includes(value);
			}

			const lastIndex = this.inputCount - 1;

			// ✅ 最后一位可以是字母、数字、学、警
			if (index === lastIndex) {
				return /^[A-Z0-9学警]$/.test(value);
			}

			// ✅ 其他位置只能是字母或数字
			return /^[A-Z0-9]$/.test(value);
		},
		onKeyPress(key) {
			if (key === '切换') {
				this.updateKeyboard();
				return;
			}

			if (key === '删除') {
				if (this.plateValue[this.currentIndex]) {
					this.$set(this.plateValue, this.currentIndex, '');
				} else if (this.currentIndex > 0) {
					this.currentIndex--;
					this.$set(this.plateValue, this.currentIndex, '');
				}
				this.updateKeyboard();
				return;
			}

			if (key === '完成') {
				this.closeKeyboard();
				return;
			}

			// ✅ 位置规则判断：学 / 警 只能在最后一位输入
			const lastIndex = this.inputCount - 1;
			if (['学', '警'].includes(key) && this.currentIndex !== lastIndex) {
				// 非最后一位点击学/警 -> 忽略
				return;
			}

			// ✅ 验证输入是否合法
			if (this.isValidInput(this.currentIndex, key)) {
				this.$set(this.plateValue, this.currentIndex, key);

				// 自动跳到下一个输入框
				if (this.currentIndex < this.inputCount - 1) {
					this.currentIndex++;
					this.updateKeyboard();
				} else {
					this.closeKeyboard();
				}
			}
		},

		// onKeyPress(key) {
		// 	if (key === '切换') {
		// 		this.updateKeyboard();
		// 		return;
		// 	}

		// 	if (key === '删除') {
		// 		if (this.plateValue[this.currentIndex]) {
		// 			this.$set(this.plateValue, this.currentIndex, '');
		// 		} else if (this.currentIndex > 0) {
		// 			this.currentIndex--;
		// 			this.$set(this.plateValue, this.currentIndex, '');
		// 		}
		// 		this.updateKeyboard();
		// 		return;
		// 	}

		// 	if (key === '完成') {
		// 		this.closeKeyboard();
		// 		return;
		// 	}

		// 	// 验证输入是否合法
		// 	if (this.isValidInput(this.currentIndex, key)) {
		// 		this.$set(this.plateValue, this.currentIndex, key);

		// 		// 自动跳到下一个输入框
		// 		if (this.currentIndex < this.inputCount - 1) {
		// 			this.currentIndex++;
		// 			this.updateKeyboard();
		// 		}
		// 	}
		// },

		updateKeyboard() {
			// 根据当前位置自动切换键盘类型
			if (this.currentIndex === 0) {
				this.currentKeys = this.provinceKeys;
			} else {
				this.currentKeys = this.normalKeys;
			}
		},

		closeKeyboard() {
			this.showKeyboard = false;
		},

		onEnergyChange() {
			if (this.isNewEnergy) {
				this.currentIndex = 7
				// 切换到新能源，确保有8个位置
				if (this.plateValue.length < 8) {
					this.plateValue.push('');
				}
			} else {
				// 切换到普通车牌，如果有第8位数据则清空
				if (this.plateValue[7]) {
					this.$set(this.plateValue, 7, '');
				}
			}
			this.updateKeyboard();
		},

				getPlateNumber() {


			const plateNumber = this.plateValue.slice(0, this.inputCount).join('');
			console.log(plateNumber, 'plateNumber');

			return plateNumber;

		},

				// 设置完整车牌号（用于回填默认值）
		setPlateNumber(plateNumber) {
			if (!plateNumber) return;

			// 清理空格、分隔符等干扰字符后转大写
			const chars = String(plateNumber)
				.replace(/[\s·-]/g, '')
				.toUpperCase()
				.split('');

			// 根据位数判断是否为新能源车牌（8位为新能源，7位为普通）
			// 注意：先设置 isNewEnergy，inputCount 计算属性会随之变化
			this.isNewEnergy = chars.length > 7;

			// 先重置所有输入位
			this.plateValue = ['', '', '', '', '', '', '', ''];

			// 逐位回填（受 inputCount 限制，最多 7 或 8 位）
			const max = this.inputCount;
			chars.forEach((char, index) => {
				if (index < max) {
					this.$set(this.plateValue, index, char);
				}
			});

			// 焦点定位：未填满则定位到第一个空位，填满则停在最后一位
			const filledLength = Math.min(chars.length, max);
			this.currentIndex = filledLength < max ? filledLength : max - 1;

			this.updateKeyboard();
		}
	}
}
</script>

<style scoped>
.license-plate-input {
	padding: 20px;
	background: white;
	border-radius: 12px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
	color: #333;
}

/* 深色模式 */
@media (prefers-color-scheme: dark) {
	.license-plate-input {
		background: #1e1e1e;
		color: #eee;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.6);
	}
}

.plate-container {
	display: flex;
	justify-content: center;
	gap: 8px;
	margin-bottom: 20px;
	padding: 20px 0;
}

.plate-item {
	width: 40px;
	height: 50px;
	border: 2px solid #e0e0e0;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #f8f9fa;
	transition: all 0.3s ease;
	position: relative;
	cursor: pointer;
}

@media (prefers-color-scheme: dark) {
	.plate-item {
		background: #2a2a2a;
		border-color: #555;
	}
}

.plate-item.active {
	border-color: #1890ff;
	box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

@media (prefers-color-scheme: dark) {
	.plate-item.active {
		box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.5);
	}
}

.plate-item.province {
	background: #e6f7ff;
	border-color: #91d5ff;
}

@media (prefers-color-scheme: dark) {
	.plate-item.province {
		background: #164056;
		border-color: #2a82c8;
	}
}

.plate-item.new-energy {
	background: #f6ffed;
	border-color: #b7eb8f;
}

@media (prefers-color-scheme: dark) {
	.plate-item.new-energy {
		background: #2a3f1f;
		border-color: #5cbf4c;
	}
}

.input-display {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 18px;
	font-weight: bold;
	color: #333;
}

@media (prefers-color-scheme: dark) {
	.input-display {
		color: #eee;
	}
}

/* 新能源选项 */
.energy-option {
	text-align: center;
	margin-bottom: 20px;
}

.checkbox {
	display: inline-flex;
	align-items: center;
	cursor: pointer;
	font-size: 14px;
	color: #666;
}

@media (prefers-color-scheme: dark) {
	.checkbox {
		color: #ccc;
	}
}

.checkbox input {
	display: none;
}

.checkmark {
	width: 18px;
	height: 18px;
	border: 2px solid #ddd;
	border-radius: 3px;
	margin-right: 8px;
	position: relative;
	transition: all 0.3s ease;
}

.checkbox input:checked+.checkmark {
	background: #1890ff;
	border-color: #1890ff;
}

.checkbox input:checked+.checkmark::after {
	content: '✓';
	position: absolute;
	color: white;
	font-size: 12px;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

/* 虚拟键盘 */
.keyboard {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	background: #f5f5f5;
	border-top: 1px solid #ddd;
	z-index: 1000;
}

@media (prefers-color-scheme: dark) {
	.keyboard {
		background: #1e1e1e;
		border-top: 1px solid #555;
	}
}

.keyboard-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 15px;
	background: white;
	border-bottom: 1px solid #eee;
	color: #333;
}

@media (prefers-color-scheme: dark) {
	.keyboard-header {
		background: #2a2a2a;
		border-bottom: 1px solid #555;
		color: #eee;
	}
}

.keyboard-header button {
	background: none;
	border: none;
	color: #1890ff;
	font-size: 14px;
	cursor: pointer;
}

.keyboard-body {
	padding: 10px;
}

.key-row {
	display: flex;
	justify-content: center;
	margin-bottom: 8px;
	gap: 4px;
}

.key {
	flex: 1;
	height: 45px;
	border: none;
	border-radius: 6px;
	background: white;
	font-size: 16px;
	cursor: pointer;
	transition: all 0.2s ease;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

@media (prefers-color-scheme: dark) {
	.key {
		background: #2a2a2a;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
		color: #eee;
	}
}

.key:active {
	background: #e6f7ff;
	transform: scale(0.95);
}

@media (prefers-color-scheme: dark) {
	.key:active {
		background: #1a6fb3;
	}
}

.key.special {
	background: #f0f0f0;
	color: #666;
	flex: 1.5;
}

@media (prefers-color-scheme: dark) {
	.key.special {
		background: #3a3a3a;
		color: #ccc;
	}
}

.key.disabled {
	background: transparent;
	box-shadow: none;
	cursor: default;
}

.key.disabled:active {
	background: transparent;
	transform: none;
}
</style>